module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Forward_16"],"path":[{"$":{"d":"M8,8,0,13V3ZM8,3V13l8-5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Forward_16.svg
// module id = Pv8v
// module chunks = 1